import { create } from "zustand";

const useThemeStore = create((set) => ({
  theme: null,
  setTheme: (theme) => {
    if (theme === "system") {
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)")
        .matches
        ? "dark"
        : "light";
      setThemeInDOM(systemTheme);
    } else {
      setThemeInDOM(theme);
    }
    set({ theme });
  },
}));

const setThemeInDOM = (theme) => {
  const root = document.documentElement;
  if (theme === "dark") {
    root.classList.add("dark");
  } else {
    root.classList.remove("dark");
  }
  localStorage.setItem("theme", theme);
};

export const initThemeFromSystem = () => {
  const stored = localStorage.getItem("theme");
  const theme = stored || "system";
  useThemeStore.getState().setTheme(theme);
};

export default useThemeStore;
